import { useState } from 'react'
import { Box, Button, Group, Paper, Stack, Text } from '@mantine/core'
import { IconArrowLeft, IconInfoCircle, IconMessageReport } from '@tabler/icons-react'
import ComplaintForm from './components/ComplaintForm'
import ComplaintList from './components/ComplaintList'
import { IsaacComplainDetailRes } from '../typings/complainTypes'

export default function Complaint() {
  const [complaints, setComplaints] = useState<IsaacComplainDetailRes[]>([])
  const [hasSearched, setHasSearched] = useState(false)

  const handleResult = (result: IsaacComplainDetailRes[]) => {
    setComplaints(result)
    setHasSearched(true)
  }

  const handleReset = () => {
    setHasSearched(false)
    setComplaints([])
  }

  const handleContactService = () => {
    window.location.href = 'tel:4000799168'
  }

  const DisclaimerNotice = () => (
    <Paper
      p="md"
      radius="md"
      style={{
        backgroundColor: '#FEF3C7',
        border: '1px solid #FCD34D',
      }}
    >
      <Stack gap="xs">
        <Group gap="xs" wrap="nowrap">
          <IconInfoCircle size={18} color="#F59E0B" style={{ flexShrink: 0, marginTop: 2 }} />
          <Text size="sm" fw={600} c="#92400E">
            温馨提示
          </Text>
        </Group>
        <Text size="sm" c="#92400E" lh={1.6} pl={26}>
          本服务提供大数据风险评估报告（非央行征信报告），如对报告内容有疑问，请
          <Text
            component="span"
            fw={600}
            style={{
              color: '#D97706',
              cursor: 'pointer',
              textDecoration: 'underline',
              margin: '0 2px',
            }}
            onClick={handleContactService}
          >
            联系客服
          </Text>
          核实处理。本服务不提供贷款等金融业务。
        </Text>
      </Stack>
    </Paper>
  )

  return (
    <div
      className="min-h-screen"
      style={{
        backgroundColor: '#F0F5FF',
      }}
    >
      <div className="w-full max-w-xl mx-auto px-3 py-6">
        <Stack gap="lg">
          <Box style={{ textAlign: 'center' }}>
            <Stack align="center" gap="xs">
              <Box
                style={{
                  padding: '12px',
                  borderRadius: '50%',
                  backgroundColor: '#1E40AF20',
                }}
              >
                <IconMessageReport size={32} color="#1E40AF" />
              </Box>
              <Text size="xl" fw={700} c="gray.8">
                投诉查询
              </Text>
              <Text size="sm" c="dimmed">
                输入手机号和身份证号查询投诉记录
              </Text>
            </Stack>
          </Box>

          {!hasSearched && (
            <Paper p="lg" radius="lg" style={{ backgroundColor: '#ffffff' }}>
              <ComplaintForm onResult={handleResult} />
            </Paper>
          )}

          {hasSearched && (
            <>
              <Paper p="md" radius="md" style={{ backgroundColor: '#ffffff' }}>
                <Group gap="sm">
                  <Button leftSection={<IconArrowLeft size={18} />} variant="light" color="blue" onClick={handleReset}>
                    重新查询
                  </Button>
                  <Text size="sm" c="dimmed">
                    查询到 {complaints.length} 条投诉记录
                  </Text>
                </Group>
              </Paper>

              <DisclaimerNotice />

              <ComplaintList complaints={complaints} />
            </>
          )}
        </Stack>
      </div>
    </div>
  )
}
